<script setup lang="ts">
import { RouterView, useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { computed, onBeforeMount, onMounted } from 'vue'
import { isObjectEmpty } from '@/utils/Utils'
const { getOnboardingData } = useUserStore()
const route = useRoute()
const router = useRouter()
const isShowBack = computed(() => {
  return route.name !== 'mentor.onboarding.step1' && route.name !== 'mentor.onboarding.step6'
})

const goBack = () => {
  if (route.name === 'mentor.onboarding.step1') {
    return
  }
  if (route.name === 'mentor.onboarding.step2') {
    return router.push({ name: 'mentor.onboarding.step1' })
  }
  if (route.name === 'mentor.onboarding.step3') {
    return router.push({ name: 'mentor.onboarding.step2' })
  }
  if (route.name === 'mentor.onboarding.step4') {
    return router.push({ name: 'mentor.onboarding.step3' })
  }
  if (route.name === 'mentor.onboarding.step5') {
    return router.push({ name: 'mentor.onboarding.step4' })
  }
}

onBeforeMount(() => {
  let status = localStorage.getItem('userStatus')
  if (status !== 'OnboardProgress') {
    router.push({ name: 'student.app' })
    return
  }
  if (isObjectEmpty(getOnboardingData.value.step1) && route.name !== 'mentor.onboarding.step6') {
    router.push({ name: 'mentor.onboarding.step1' })
  }
})
</script>

<template>
  <div class="shadow-custom justify-center flex py-5 px-10">
    <a @click.prevent="goBack" v-if="isShowBack" class="headerBack" href="#">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.95406 12.7959L9.70406 19.5459C9.91541 19.7573 10.2021 19.876 10.5009 19.876C10.7998 19.876 11.0865 19.7573 11.2978 19.5459C11.5092 19.3346 11.6279 19.0479 11.6279 18.749C11.6279 18.4502 11.5092 18.1635 11.2978 17.9522L6.46875 13.125H20.25C20.5484 13.125 20.8345 13.0065 21.0455 12.7955C21.2565 12.5845 21.375 12.2984 21.375 12C21.375 11.7016 21.2565 11.4155 21.0455 11.2045C20.8345 10.9935 20.5484 10.875 20.25 10.875H6.46875L11.2959 6.04498C11.5073 5.83364 11.626 5.54699 11.626 5.24811C11.626 4.94922 11.5073 4.66258 11.2959 4.45123C11.0846 4.23989 10.7979 4.12115 10.4991 4.12115C10.2002 4.12115 9.91353 4.23989 9.70219 4.45123L2.95219 11.2012C2.84729 11.3059 2.7641 11.4302 2.7074 11.5671C2.65069 11.704 2.62159 11.8508 2.62177 11.999C2.62194 12.1471 2.65139 12.2938 2.70841 12.4306C2.76544 12.5674 2.84892 12.6915 2.95406 12.7959Z"
          fill="currentColor"
        />
      </svg>
    </a>
    <div class="w-12 h-8">
      <RouterLink to="/mentor/onboarding">
        <img src="/images/logo.png" alt="" />
      </RouterLink>
    </div>
  </div>
  <div class="py-[120px]">
    <div class="container mx-auto">
      <div class="px-4 md:w-7/12 lg:w-7/12 xl:w-4/12 mx-auto">
        <RouterView />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.headerBack {
  position: absolute;
  top: 25px;
  left: 20px;
  z-index: 100;
  @apply text-gray-700;
}
</style>
